"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var noop_1 = require("rxjs/util/noop");
var lodash_1 = require("lodash");
require("./inline-sis-table-settings.component.scss");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var InlineSisTableSettingsComponent = /** @class */ (function (_super) {
    __extends(InlineSisTableSettingsComponent, _super);
    function InlineSisTableSettingsComponent(communicationService, kbService) {
        var _this = _super.call(this, communicationService) || this;
        _this.communicationService = communicationService;
        _this.kbService = kbService;
        _this.isAddable = true;
        _this.isDeletable = true;
        _this.colSystemNames = [];
        _this.allColumns = [];
        _this.allMetaFields = [];
        return _this;
    }
    Object.defineProperty(InlineSisTableSettingsComponent.prototype, "state", {
        set: function (state) {
            this.isAddable = state.hasOwnProperty('isAddable')
                ? typeof state['isAddable'] === 'string'
                    ? state['isAddable'] === 'true'
                    : state['isAddable']
                : null;
            this.isDeletable = state.hasOwnProperty('isDeletable')
                ? typeof state['isDeletable'] === 'string'
                    ? state['isDeletable'] === 'true'
                    : state['isDeletable']
                : null;
            this.colSystemNames =
                state.hasOwnProperty('colSystemNames') &&
                    lodash_1.isArray(state['colSystemNames']) &&
                    !lodash_1.isEmpty(state['colSystemNames'])
                    ? state['colSystemNames']
                    : this.generateColumnDataItems(this.allMetaFields).map(function (item) { return item.value.id; });
            if (state['tooltipSettings']) {
                this._tooltipSettings = idm_ng_controls_1.TooltipSettings.fromJsonString(state['tooltipSettings']);
            }
            if (state['tooltipSettings']) {
                this._tooltipSettings = idm_ng_controls_1.TooltipSettings.fromJsonString(state['tooltipSettings']);
            }
            if (state['controlLabel']) {
                this._controlLabel = state['controlLabel'];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InlineSisTableSettingsComponent.prototype, "fields", {
        set: function (fields) {
            this._subEntityMetaField = fields.field;
        },
        enumerable: true,
        configurable: true
    });
    InlineSisTableSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this._subEntityMetaField) {
            var compoundCategorySystemName_1 = this._subEntityMetaField
                .getCompoundCategorySystemName
                ? this._subEntityMetaField.getCompoundCategorySystemName()
                : this._subEntityMetaField['compoundCategorySystemName'];
            this.kbService
                .getMetaFields(compoundCategorySystemName_1)
                .pipe(operators_1.first(), operators_1.tap(function (metaFields) {
                _this.allMetaFields = metaFields.filter(function (metafield) {
                    return (metafield.getType() ===
                        idm_kb_service_client_js_1.MetaFieldType.DATE ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.DOCUMENT ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.STRING ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.DECIMAL ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.INTEGER ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.MONEY ||
                        metafield.getType() ===
                            idm_kb_service_client_js_1.MetaFieldType.BOOLEAN);
                });
                var allItems = _this.generateColumnDataItems(_this.allMetaFields);
                _this.allColumns.push({
                    items: allItems,
                    name: compoundCategorySystemName_1,
                });
                if (lodash_1.isNil(_this.colSystemNames) ||
                    lodash_1.isEmpty(_this.colSystemNames)) {
                    _this.colSystemNames = allItems.map(function (item) { return item.value.id; });
                }
            }))
                .subscribe(noop_1.noop, console.error);
        }
    };
    InlineSisTableSettingsComponent.prototype.changeIsAddable = function (value) {
        this.isAddable = value;
        this.changeSettings();
    };
    InlineSisTableSettingsComponent.prototype.changeIsDeletable = function (value) {
        this.isDeletable = value;
        this.changeSettings();
    };
    InlineSisTableSettingsComponent.prototype.changeColSystemNames = function (value) {
        this.colSystemNames = value;
        this.changeSettings();
    };
    InlineSisTableSettingsComponent.prototype.onOrderChange = function (value) {
        this.colSystemNames = value;
        this.changeSettings();
    };
    InlineSisTableSettingsComponent.prototype.isEditForm = function () {
        return this.formType === idm_dynamic_layout_interpreter_1.FormType.EDIT;
    };
    InlineSisTableSettingsComponent.prototype.generateColumnDataItems = function (metafields) {
        var _this = this;
        return metafields.map(function (field, index) {
            return {
                name: field
                    .getDisplayNameMultilingual()
                    .getValue(_this.currentLanguageId),
                value: {
                    name: field
                        .getDisplayNameMultilingual()
                        .getValue(_this.currentLanguageId),
                    id: field.getSystemName(),
                },
            };
        });
    };
    InlineSisTableSettingsComponent.prototype.changeSettings = function () {
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            bindings: {},
            state: {
                isAddable: this.isAddable,
                isDeletable: this.isDeletable,
                colSystemNames: this.colSystemNames,
            },
        }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], InlineSisTableSettingsComponent.prototype, "formType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], InlineSisTableSettingsComponent.prototype, "state", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], InlineSisTableSettingsComponent.prototype, "fields", null);
    InlineSisTableSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'inline-sis-table-settings',
            template: require('./inline-sis-table-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n                <inline-sis-table-settings [state]=\"%{state}\" [languages]=\"%{languages}\"\n                    [formType]=\"%{formType}\"\n                    [currentLanguageId]=\"%{currentLanguageId}\" [controlLabel]=\"%{controlLabel}\"\n                    [fields]=\"%{fields}\">\n                </inline-sis-table-settings>",
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
            idm_kb_service_client_js_1.KbService])
    ], InlineSisTableSettingsComponent);
    return InlineSisTableSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.InlineSisTableSettingsComponent = InlineSisTableSettingsComponent;
//# sourceMappingURL=inline-sis-table-settings.component.js.map